import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import { __decorate } from "tslib";
import Vue from "vue";
import { Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator"; // import Components from "./index";

var FrontalePreviewIncernierati = function FrontalePreviewIncernierati() {
  return import("./FrontalePreviewIncernierati.vue");
};

var FrontalePreview = function FrontalePreview() {
  return import("./FrontalePreview.vue");
};

var ColorGridIncisione = function ColorGridIncisione() {
  return import("./ColorGridIncisione.vue");
};

var ExtAstaDxPreview = function ExtAstaDxPreview() {
  return import("./ExtAstaDxPreview.vue");
};

var ExtAstaSxPreview = function ExtAstaSxPreview() {
  return import("./ExtAstaSxPreview.vue");
};

var IntAstaDxPreview = function IntAstaDxPreview() {
  return import("./IntAstaDxPreview.vue");
};

var IntAstaSxPreview = function IntAstaSxPreview() {
  return import("./IntAstaSxPreview.vue");
};

var ExtAstaSxBoldPreviewIncernierati = function ExtAstaSxBoldPreviewIncernierati() {
  return import("./ExtAstaSxBoldPreviewIncernierati.vue");
};

var ExtAstaDxBoldPreviewIncernierati = function ExtAstaDxBoldPreviewIncernierati() {
  return import("./ExtAstaDxBoldPreviewIncernierati.vue");
};

var IntAstaDxBoldPreviewIncernierati = function IntAstaDxBoldPreviewIncernierati() {
  return import("./IntAstaDxBoldPreviewIncernierati.vue");
};

var IntAstaSxBoldPreviewIncernierati = function IntAstaSxBoldPreviewIncernierati() {
  return import("./IntAstaSxBoldPreviewIncernierati.vue");
};

var ExtAstaSxThinPreviewIncernierati = function ExtAstaSxThinPreviewIncernierati() {
  return import("./ExtAstaSxThinPreviewIncernierati.vue");
};

var ExtAstaDxThinPreviewIncernierati = function ExtAstaDxThinPreviewIncernierati() {
  return import("./ExtAstaDxThinPreviewIncernierati.vue");
};

var IntAstaDxThinPreviewIncernierati = function IntAstaDxThinPreviewIncernierati() {
  return import("./IntAstaDxThinPreviewIncernierati.vue");
};

var IntAstaSxThinPreviewIncernierati = function IntAstaSxThinPreviewIncernierati() {
  return import("./IntAstaSxThinPreviewIncernierati.vue");
};

var ComponenteIncisione = /*#__PURE__*/function (_Vue) {
  _inherits(ComponenteIncisione, _Vue);

  var _super = _createSuper(ComponenteIncisione);

  function ComponenteIncisione() {
    var _this;

    _classCallCheck(this, ComponenteIncisione);

    _this = _super.apply(this, arguments);
    _this.itemActive = "";
    _this.isCartButtonDisabled = true;
    _this.namePosition = "ext";
    _this.activePreview = null;
    _this.colors = [{
      name: "nero",
      colorCode: "#212121",
      colorClass: "grey darken-4",
      checkColor: "white"
    }, {
      name: "bianco",
      colorCode: "#fafafa",
      colorClass: "grey lighten-5",
      checkColor: "grey"
    }, {
      name: "verde",
      colorCode: "#4caf50",
      colorClass: "green",
      checkColor: "white"
    }, {
      name: "blu",
      colorCode: "#2196f3",
      colorClass: "blu",
      checkColor: "white"
    }, {
      name: "giallo",
      colorCode: "#FFEB3B",
      colorClass: "yellow",
      checkColor: "grey"
    }, {
      name: "rosso",
      colorCode: "#f44336",
      colorClass: "red",
      checkColor: "white"
    }, {
      name: "rosa",
      colorCode: "#F8BBD0",
      colorClass: "pink",
      checkColor: "white"
    }, {
      name: "arancione",
      colorCode: "#FF9800",
      colorClass: "orange",
      checkColor: "white"
    }, {
      name: "viola",
      colorCode: "#AB47BC",
      colorClass: "purple",
      checkColor: "white"
    }, {
      name: "oro",
      colorCode: "#FFD700",
      colorClass: "gold",
      checkColor: "white"
    }, {
      name: "argento",
      colorCode: "#D3D3D3",
      colorClass: "silver",
      checkColor: "white"
    }, {
      name: "azzurro",
      colorCode: "#81D4FA",
      colorClass: "light blue",
      checkColor: "white"
    }, {
      name: "",
      colorCode: "#f4f4f4",
      colorClass: "no color",
      checkColor: ""
    }];
    _this.selectedFont = "";
    return _this;
  } // --- Engraving configuration overrides from user ---
  // Expected structure in store: state.configurator.user.clientEngravingConfigurations
  // Each config item example: { position: 'extDx' | 'intDx' | 'extSx' | 'intSx' | 'front', text: string, description?: string, color?: string }


  _createClass(ComponenteIncisione, [{
    key: "userEngravingConfigurations",
    get: function get() {
      try {
        var _this$$store$state, _this$$store$state$co, _this$$store$state$co2;

        // @ts-ignore
        var raw = (_this$$store$state = this.$store.state) === null || _this$$store$state === void 0 ? void 0 : (_this$$store$state$co = _this$$store$state.configurator) === null || _this$$store$state$co === void 0 ? void 0 : (_this$$store$state$co2 = _this$$store$state$co.user) === null || _this$$store$state$co2 === void 0 ? void 0 : _this$$store$state$co2.clientEngravingConfigurations;
        return Array.isArray(raw) ? raw : [];
      } catch (e) {
        return [];
      }
    }
  }, {
    key: "currentPositionKey",
    get: function get() {
      if (this.itemActive === 'AstaDx') return this.namePosition === 'int' ? '45585' : '45583';
      if (this.itemActive === 'AstaSx') return this.namePosition === 'int' ? '45584' : '45586';
      return null;
    }
  }, {
    key: "activeItemCode",
    get: function get() {
      var _this$$store$state2, _this$$store$state2$c, _this$$store$state2$c2;

      return String(((_this$$store$state2 = this.$store.state) === null || _this$$store$state2 === void 0 ? void 0 : (_this$$store$state2$c = _this$$store$state2.configurator) === null || _this$$store$state2$c === void 0 ? void 0 : (_this$$store$state2$c2 = _this$$store$state2$c.frontale) === null || _this$$store$state2$c2 === void 0 ? void 0 : _this$$store$state2$c2.ItemCode) || "").trim();
    }
  }, {
    key: "currentPredef",
    get: function get() {
      var _this$$store$getters;

      var key = this.currentPositionKey;
      if (!key) return null;
      var getStandardEngraving = (_this$$store$getters = this.$store.getters) === null || _this$$store$getters === void 0 ? void 0 : _this$$store$getters["configurator/user/getStandardEngraving"];

      if (typeof getStandardEngraving === "function") {
        var resolved = getStandardEngraving(this.activeItemCode, key);
        if (resolved) return resolved;
      } // Fallback legacy (vecchio payload array)


      var legacyCfg = Array.isArray(this.userEngravingConfigurations) ? this.userEngravingConfigurations.find(function (c) {
        return (c === null || c === void 0 ? void 0 : c.engraving_position) === key;
      }) : null;
      return legacyCfg || null;
    }
  }, {
    key: "isPredefined",
    get: function get() {
      return !!this.currentPredef;
    }
  }, {
    key: "predefinedText",
    get: function get() {
      var _this$currentPredef$e;

      return this.currentPredef && ((_this$currentPredef$e = this.currentPredef.engraving) === null || _this$currentPredef$e === void 0 ? void 0 : _this$currentPredef$e.replaceAll('%logo%', '[LOGO]')) || '';
    }
  }, {
    key: "isPredefinedUrl",
    get: function get() {
      var t = this.predefinedText || '';
      return /^https?:\/\//i.test(t);
    }
  }, {
    key: "predefinedColor",
    get: function get() {
      return this.currentPredef && this.currentPredef.color || '';
    }
  }, {
    key: "maxLength",
    get: function get() {
      var _this$temple;

      var modello = ((_this$temple = this.temple) === null || _this$temple === void 0 ? void 0 : _this$temple.U_THE_MODELLO) || "";
      var maxLength;

      if (modello.includes("12") || modello.includes("75")) {
        maxLength = this.namePosition === "int" ? 10 : 25;
      } else {
        maxLength = 25;
      }

      return maxLength;
    }
  }, {
    key: "resetPersonalization",
    value: function resetPersonalization() {
      this.testo = ""; // Resetta il testo

      this.colore = null; // Resetta il colore

      this.font = ""; // Resetta il font
    }
  }, {
    key: "frontale",
    get: function get() {
      return this.$store.state.configurator.frontale;
    }
  }, {
    key: "fontType",
    get: function get() {
      return this.$store.state.configurator.fontType;
    }
  }, {
    key: "testo",
    get: function get() {
      if (this.itemActive == "Frontale") {
        return this.$store.state.configurator.frontali.cilDxNome;
      } else if (this.itemActive == "AstaDx" && this.namePosition == "int") {
        return this.$store.state.configurator.aste.intDxName;
      } else if (this.itemActive == "AstaDx" && this.namePosition == "ext") {
        return this.$store.state.configurator.aste.extDxName;
      } else if (this.itemActive == "AstaSx" && this.namePosition == "int") {
        return this.$store.state.configurator.aste.intSxName;
      } else if (this.itemActive == "AstaSx" && this.namePosition == "ext") {
        return this.$store.state.configurator.aste.extSxName;
      }

      return "";
    },
    set: function set(c) {
      if (this.isPredefined) {
        // Ignore manual edits when predefined
        return;
      }

      if (this.itemActive == "Frontale") {
        this.$store.commit("configurator/frontali/setCilDxNome", c);
      } else if (this.itemActive == "AstaDx" && this.namePosition == "int") {
        this.$store.commit("configurator/aste/setIntDxName", c);
      } else if (this.itemActive == "AstaDx" && this.namePosition == "ext") {
        this.$store.commit("configurator/aste/setExtDxName", c);
      } else if (this.itemActive == "AstaSx" && this.namePosition == "int") {
        this.$store.commit("configurator/aste/setIntSxName", c);
      } else if (this.itemActive == "AstaSx" && this.namePosition == "ext") {
        this.$store.commit("configurator/aste/setExtSxName", c);
      }
    }
  }, {
    key: "font",
    get: function get() {
      if (this.itemActive == "Frontale") {
        return this.$store.state.configurator.frontali.cilDxFont;
      } else if (this.itemActive == "AstaDx" && this.namePosition == "int") {
        return this.$store.state.configurator.aste.intDxNameFont;
      } else if (this.itemActive == "AstaDx" && this.namePosition == "ext") {
        return this.$store.state.configurator.aste.extDxNameFont;
      } else if (this.itemActive == "AstaSx" && this.namePosition == "int") {
        return this.$store.state.configurator.aste.intSxNameFont;
      } else if (this.itemActive == "AstaSx" && this.namePosition == "ext") {
        return this.$store.state.configurator.aste.extSxNameFont;
      }

      return "";
    },
    set: function set(f) {
      if (this.isPredefined) {
        // Prevent font changes when predefined
        return;
      }

      if (this.itemActive == "Frontale") {
        this.$store.commit("configurator/frontali/setCilDxFont", f);
      } else if (this.itemActive == "AstaDx" && this.namePosition == "int") {
        this.$store.commit("configurator/aste/setIntDxNameFont", f);
      } else if (this.itemActive == "AstaDx" && this.namePosition == "ext") {
        this.$store.commit("configurator/aste/setExtDxNameFont", f);
      } else if (this.itemActive == "AstaSx" && this.namePosition == "int") {
        this.$store.commit("configurator/aste/setIntSxNameFont", f);
      } else if (this.itemActive == "AstaSx" && this.namePosition == "ext") {
        this.$store.commit("configurator/aste/setExtSxNameFont", f);
      }
    }
  }, {
    key: "colore",
    get: function get() {
      if (this.itemActive == "Frontale") {
        return this.$store.state.configurator.frontali.cilDxColore;
      } else if (this.itemActive == "AstaDx" && this.namePosition == "int") {
        return this.$store.state.configurator.aste.intDxNameColor;
      } else if (this.itemActive == "AstaDx" && this.namePosition == "ext") {
        return this.$store.state.configurator.aste.extDxNameColor;
      } else if (this.itemActive == "AstaSx" && this.namePosition == "int") {
        return this.$store.state.configurator.aste.intSxNameColor;
      } else if (this.itemActive == "AstaSx" && this.namePosition == "ext") {
        return this.$store.state.configurator.aste.extSxNameColor;
      }

      return "";
    },
    set: function set(c) {
      if (this.isPredefined) {
        // Prevent color changes when predefined
        return;
      }

      if (this.itemActive == "Frontale") {
        this.$store.commit("configurator/frontali/setCilDxColore", c);
      } else if (this.itemActive == "AstaDx" && this.namePosition == "int") {
        this.$store.commit("configurator/aste/setIntDxNameColor", c);
      } else if (this.itemActive == "AstaDx" && this.namePosition == "ext") {
        this.$store.commit("configurator/aste/setExtDxNameColor", c);
      } else if (this.itemActive == "AstaSx" && this.namePosition == "int") {
        this.$store.commit("configurator/aste/setIntSxNameColor", c);
      } else if (this.itemActive == "AstaSx" && this.namePosition == "ext") {
        this.$store.commit("configurator/aste/setExtSxNameColor", c);
      }
    }
  }, {
    key: "selectedColor",
    get: function get() {
      var _this2 = this;

      return this.colors.filter(function (c) {
        return c.name == _this2.colore;
      })[0];
    }
  }, {
    key: "selectedPredefinedColor",
    get: function get() {
      var _this3 = this;

      return this.colors.filter(function (c) {
        return c.name == _this3.predefinedColor;
      })[0];
    }
  }, {
    key: "setColore",
    value: function setColore(c) {
      // Guard when predefined
      if (this.isPredefined) return;
      this.colore = c.name;
    }
  }, {
    key: "previewComponent",
    value: function previewComponent(item, side) {
      var _this$temple2;

      if (!item) return null;
      var modello = "";
      modello = ((_this$temple2 = this.temple) === null || _this$temple2 === void 0 ? void 0 : _this$temple2.U_THE_MODELLO) || "";

      if (!side) {
        var _this$frontale;

        if (((_this$frontale = this.frontale) === null || _this$frontale === void 0 ? void 0 : _this$frontale.U_THE_TECNOLOGIA) === "AFF") {
          return FrontalePreviewIncernierati;
        }

        return FrontalePreview;
      } else {
        if (modello.includes("12")) {
          // Carica le aste incernierate bold
          if (side === "int" && item["int"] && this.namePosition === "int") {
            return item.nome.toUpperCase().includes("SX") ? IntAstaSxBoldPreviewIncernierati : IntAstaDxBoldPreviewIncernierati;
          } else if (side === "ext" && item.ext && this.namePosition === "ext") {
            return item.nome.toUpperCase().includes("DX") ? ExtAstaDxBoldPreviewIncernierati : ExtAstaSxBoldPreviewIncernierati;
          }
        } else if (modello.includes("75")) {
          // Carica le aste incernierate thin
          if (side === "int" && item["int"] && this.namePosition === "int") {
            return item.nome.toUpperCase().includes("SX") ? IntAstaSxThinPreviewIncernierati : IntAstaDxThinPreviewIncernierati;
          } else if (side === "ext" && item.ext && this.namePosition === "ext") {
            return item.nome.toUpperCase().includes("DX") ? ExtAstaDxThinPreviewIncernierati : ExtAstaSxThinPreviewIncernierati;
          }
        } else {
          // Carica la preview corrente
          if (side === "int" && item["int"] && this.namePosition === "int") {
            return item.nome.toUpperCase().includes("SX") ? IntAstaSxPreview : IntAstaDxPreview;
          } else if (side === "ext" && item.ext && this.namePosition === "ext") {
            return item.nome.toUpperCase().includes("DX") ? ExtAstaDxPreview : ExtAstaSxPreview;
          }
        }
      }

      return null;
    }
  }, {
    key: "onModelChange",
    value: function onModelChange(newVal) {
      if (newVal) {
        // Calcola il limite massimo di caratteri per il nuovo modello
        var newMaxLength = newVal.includes("12") || newVal.includes("75") ? 10 : 25; // Controlla se il testo supera il nuovo limite

        if (this.testo.length > newMaxLength) {
          this.resetPersonalization(); // Aggiorna lo stato Vuex per indicare che la personalizzazione è stata rimossa

          this.$store.commit("setPersonalizationRemoved", true);

          _Message({
            message: String(this.$t("message.La_tua_personalizzazione_è_stata_rimossa_cambiando_il_modello")),
            type: "warning"
          });
        } // Forza l'aggiornamento del testo per rispettare il nuovo limite


        this.testo = this.testo.slice(0, newMaxLength);
      }
    } // Apply predefined text/color whenever relevant sources change

  }, {
    key: "applyPredefined",
    value: function applyPredefined() {
      if (this.isPredefined) {
        if (this.predefinedText && this.testo !== this.predefinedText) {
          this.testo = this.predefinedText;
        }
      }
    }
  }]);

  return ComponenteIncisione;
}(Vue);

__decorate([Prop()], ComponenteIncisione.prototype, "persComponent", void 0);

__decorate([Prop()], ComponenteIncisione.prototype, "itemActive", void 0);

__decorate([Prop()], ComponenteIncisione.prototype, "temple", void 0);

__decorate([Watch("temple.U_THE_MODELLO", {
  immediate: true
})], ComponenteIncisione.prototype, "onModelChange", null);

__decorate([Watch("currentPositionKey", {
  immediate: true
}), Watch("userEngravingConfigurations")], ComponenteIncisione.prototype, "applyPredefined", null);

ComponenteIncisione = __decorate([Component({
  components: {
    FrontalePreview: FrontalePreview,
    ColorGridIncisione: ColorGridIncisione,
    ExtAstaDxPreview: ExtAstaDxPreview,
    ExtAstaSxPreview: ExtAstaSxPreview,
    IntAstaDxPreview: IntAstaDxPreview,
    IntAstaSxPreview: IntAstaSxPreview,
    ExtAstaSxBoldPreviewIncernierati: ExtAstaSxBoldPreviewIncernierati,
    ExtAstaDxBoldPreviewIncernierati: ExtAstaDxBoldPreviewIncernierati,
    IntAstaDxBoldPreviewIncernierati: IntAstaDxBoldPreviewIncernierati,
    IntAstaSxBoldPreviewIncernierati: IntAstaSxBoldPreviewIncernierati,
    ExtAstaSxThinPreviewIncernierati: ExtAstaSxThinPreviewIncernierati,
    ExtAstaDxThinPreviewIncernierati: ExtAstaDxThinPreviewIncernierati,
    IntAstaDxThinPreviewIncernierati: IntAstaDxThinPreviewIncernierati,
    IntAstaSxThinPreviewIncernierati: IntAstaSxThinPreviewIncernierati
  }
})], ComponenteIncisione);
export default ComponenteIncisione;